(window.webpackJsonp=window.webpackJsonp||[]).push([[512],{
/***/"7jfz":
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"d",(function(){return n})),
/* harmony export (binding) */s.d(t,"a",(function(){return i})),
/* harmony export (binding) */s.d(t,"b",(function(){return l})),
/* harmony export (binding) */s.d(t,"c",(function(){return a}));
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const n=!(window.ShadyDOM&&window.ShadyDOM.inUse);let r,i;
/**
 * @param {(ShadyCSSOptions | ShadyCSSInterface)=} settings
 */function o(e){r=(!e||!e.shimcssproperties)&&(n||Boolean(!navigator.userAgent.match(/AppleWebKit\/601|Edge\/15/)&&window.CSS&&CSS.supports&&CSS.supports("box-shadow","0 0 0 var(--foo)")))}
/** @type {string | undefined} */window.ShadyCSS&&void 0!==window.ShadyCSS.cssBuild&&(i=window.ShadyCSS.cssBuild)
/** @type {boolean} */;const l=Boolean(window.ShadyCSS&&window.ShadyCSS.disableRuntime);window.ShadyCSS&&void 0!==window.ShadyCSS.nativeCss?r=window.ShadyCSS.nativeCss:window.ShadyCSS?(o(window.ShadyCSS),// reset window variable to let ShadyCSS API take its place
window.ShadyCSS=void 0):o(window.WebComponents&&window.WebComponents.flags);// Hack for type error under new type inference which doesn't like that
// nativeCssVariables is updated in a function and assigns the type
// `function(): ?` instead of `boolean`.
const a=
/** @type {boolean} */
r;
/***/},
/***/"9Cpw":
/***/function(e,t,s){"use strict";
/* harmony import */var n=s("gXhW"),r=s("i8Lh"),i=s("7jfz");
/* harmony import */
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// prettier-ignore
// prettier-ignore
const o=new n.a;window.ShadyCSS||(window.ShadyCSS={
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     * @param {string=} elementExtends
     */
prepareTemplate(e,t,s){},
// eslint-disable-line @typescript-eslint/no-unused-vars
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     */
prepareTemplateDom(e,t){},
// eslint-disable-line @typescript-eslint/no-unused-vars
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     * @param {string=} elementExtends
     */
prepareTemplateStyles(e,t,s){},
// eslint-disable-line @typescript-eslint/no-unused-vars
/**
     * @param {Element} element
     * @param {Object=} properties
     */
styleSubtree(e,t){o.processStyles(),Object(r.c)(e,t)},
/**
     * @param {Element} element
     */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
styleElement(e){o.processStyles()},
/**
     * @param {Object=} properties
     */
styleDocument(e){o.processStyles(),Object(r.c)(document.body,e)},
/**
     * @param {Element} element
     * @param {string} property
     * @return {string}
     */
getComputedStyleValue:(e,t)=>Object(r.b)(e,t),flushCustomStyles(){},nativeCss:i.c,nativeShadow:i.d,cssBuild:i.a,disableRuntime:i.b}),window.ShadyCSS.CustomStyleInterface=o},
/***/O2xI:
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"c",(function(){return n})),
/* harmony export (binding) */s.d(t,"b",(function(){return r})),
/* unused harmony export VAR_CONSUMED */
/* unused harmony export ANIMATION_MATCH */
/* harmony export (binding) */s.d(t,"a",(function(){return i}));
/* unused harmony export IS_VAR */
/* unused harmony export BRACKETED */
/* unused harmony export HOST_PREFIX */
/* unused harmony export HOST_SUFFIX */
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const n=/(?:^|[;\s{]\s*)(--[\w-]*?)\s*:\s*(?:((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};{])+)|\{([^}]*)\}(?:(?=[;\s}])|$))/gi,r=/(?:^|\W+)@apply\s*\(?([^);\n]*)\)?/gi,i=/@media\s(.*)/},
/***/SMGt:
/***/function(e,t,s){"use strict";
/* harmony import */var n=s("fc5Q"),r=s("xw6Y"),i=s("xBrN"),o=s("p1N8"),l=s("F3iu");
/* harmony import */
/**
 * `fontawesome-icon`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class a extends l.a{static get template(){return l.b`
      <div id="container"></div>
    `}static get properties(){return{
/** FontAwesome icon prefix */
prefix:String,
/** FontAwesome icon name */
name:String,
/** FontAwesome fixed width parameter (fa-fw) */
fixedWidth:Boolean,
/** FontAwesom spin option (fa-spin) */
spin:Boolean}}static get observers(){return["_iconChanged(prefix, name, fixedWidth, spin)"]}constructor(){super(),n.d.add(r.a,i.a,o.a)}ready(){super.ready();let e=document.createElement("style");e.innerHTML=n.a.css(),this.root.appendChild(e)}_iconChanged(e,t,s,r){let i=n.b({prefix:e,iconName:t});i||(i=n.b({prefix:"far",iconName:"question-circle"}));let o={classes:[]};s&&o.classes.push("fa-fw"),r&&o.classes.push("fa-spin"),this.$.container.innerHTML=n.c(i,o).html}}window.customElements.define("fontawesome-icon",a)},
/***/gXhW:
/***/function(e,t,s){"use strict";
// EXPORTS
s.d(t,"a",(function(){/* binding */return c}));
// UNUSED EXPORTS: CustomStyleProvider, CustomStyleInterfaceInterface
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/document-wait.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/** @type {Promise<void>} */
let n,r=null,i=window.HTMLImports&&window.HTMLImports.whenReady||null;
/** @type {?function(?function())} */
/**
 * @param {?function()} callback
 */
function o(e){requestAnimationFrame((function(){i?i(e):(r||(r=new Promise(e=>{n=e}),"complete"===document.readyState?n():document.addEventListener("readystatechange",()=>{"complete"===document.readyState&&n()})),r.then((function(){e&&e()})))}))}
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/custom-style-interface.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @typedef {HTMLStyleElement | {getStyle: function():HTMLStyleElement}}
 */const l="__shadyCSSCachedStyle";
/** @type {?function(!HTMLStyleElement)} */
let a=null,u=null;
/** @type {?function()} */
/**
This interface is provided to add document-level <style> elements to ShadyCSS for processing.
These styles must be processed by ShadyCSS to simulate ShadowRoot upper-bound encapsulation from outside styles
In addition, these styles may also need to be processed for @apply rules and CSS Custom Properties

To add document-level styles to ShadyCSS, one can call `ShadyCSS.addDocumentStyle(styleElement)` or `ShadyCSS.addDocumentStyle({getStyle: () => styleElement})`

In addition, if the process used to discover document-level styles can be synchronously flushed, one should set `ShadyCSS.documentStyleFlush`.
This function will be called when calculating styles.

An example usage of the document-level styling api can be found in `examples/document-style-lib.js`

@unrestricted
*/
class c{constructor(){
/** @type {!Array<!CustomStyleProvider>} */
this.customStyles=[],this.enqueued=!1,// NOTE(dfreedm): use quotes here to prevent closure inlining to `function(){}`;
o(()=>{window.ShadyCSS.flushCustomStyles&&window.ShadyCSS.flushCustomStyles()})}
/**
   * Queue a validation for new custom styles to batch style recalculations
   */enqueueDocumentValidation(){!this.enqueued&&u&&(this.enqueued=!0,o(u))}
/**
   * @param {!HTMLStyleElement} style
   */addCustomStyle(e){e.__seenByShadyCSS||(e.__seenByShadyCSS=!0,this.customStyles.push(e),this.enqueueDocumentValidation())}
/**
   * @param {!CustomStyleProvider} customStyle
   * @return {HTMLStyleElement}
   */getStyleForCustomStyle(e){if(e[l])return e[l];let t;return t=e.getStyle?e.getStyle():e,t}
/**
   * @return {!Array<!CustomStyleProvider>}
   */processStyles(){const e=this.customStyles;for(let t=0;t<e.length;t++){const s=e[t];if(s[l])continue;const n=this.getStyleForCustomStyle(s);if(n){
// HTMLImports polyfill may have cloned the style into the main document,
// which is referenced with __appliedElement.
const e=
/** @type {!HTMLStyleElement} */
n.__appliedElement||n;a&&a(e),s[l]=e}}return e}}
/* eslint-disable no-self-assign */c.prototype.addCustomStyle=c.prototype.addCustomStyle,c.prototype.getStyleForCustomStyle=c.prototype.getStyleForCustomStyle,c.prototype.processStyles=c.prototype.processStyles,
/* eslint-enable no-self-assign */
Object.defineProperties(c.prototype,{transformCallback:{
/** @return {?function(!HTMLStyleElement)} */
get:()=>a,
/** @param {?function(!HTMLStyleElement)} fn */
set(e){a=e}},validateCallback:{
/** @return {?function()} */
get:()=>u,
/**
     * @param {?function()} fn
     * @this {CustomStyleInterface}
     */
set(e){let t=!1;u||(t=!0),u=e,t&&this.enqueueDocumentValidation()}}})},
/***/gkuc:
/***/function(e,t,s){"use strict";
// EXTERNAL MODULE: ./node_modules/@webcomponents/shadycss/src/style-settings.js?babel-target=es6
var n=s("7jfz");
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/css-parse.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/*
Extremely simple css parser. Intended to be not more than what we need
and definitely not necessarily correct =).
*/
/** @unrestricted */class r{constructor(){
/** @type {number} */
this.start=0,
/** @type {number} */
this.end=0,
/** @type {StyleNode} */
this.previous=null,
/** @type {StyleNode} */
this.parent=null,
/** @type {Array<StyleNode>} */
this.rules=null,
/** @type {string} */
this.parsedCssText="",
/** @type {string} */
this.cssText="",
/** @type {boolean} */
this.atRule=!1,
/** @type {number} */
this.type=0,
/** @type {string} */
this.keyframesName="",
/** @type {string} */
this.selector="",
/** @type {string} */
this.parsedSelector=""}}
// given a string of css, return a simple rule tree
/**
 * @param {string} text
 * @return {StyleNode}
 */function i(e){// add selectors/cssText to node tree
/**
 * @param {StyleNode} node
 * @param {string} text
 * @return {!StyleNode}
 */
return function e(t,s){let n=s.substring(t.start,t.end-1);if(t.parsedCssText=t.cssText=n.trim(),t.parent){let e=t.previous?t.previous.end:t.parent.start;n=s.substring(e,t.start-1),n=
/**
 * conversion of sort unicode escapes with spaces like `\33 ` (and longer) into
 * expanded form that doesn't require trailing space `\000033`
 * @param {string} s
 * @return {string}
 */
function(e){return e.replace(/\\([0-9a-f]{1,6})\s/gi,(function(){let e=arguments[1],t=6-e.length;for(;t--;)e="0"+e;return"\\"+e}))}
/**
 * stringify parsed css.
 * @param {StyleNode} node
 * @param {boolean=} preserveProperties
 * @param {string=} text
 * @return {string}
 */(n),n=n.replace(c.multipleSpaces," "),// TODO(sorvell): ad hoc; make selector include only after last ;
// helps with mixin syntax
n=n.substring(n.lastIndexOf(";")+1);let r=t.parsedSelector=t.selector=n.trim();t.atRule=0===r.indexOf(m),// note, support a subset of rule types...
t.atRule?0===r.indexOf(d)?t.type=l.MEDIA_RULE:r.match(c.keyframesRule)&&(t.type=l.KEYFRAMES_RULE,t.keyframesName=t.selector.split(c.multipleSpaces).pop()):0===r.indexOf(p)?t.type=l.MIXIN_RULE:t.type=l.STYLE_RULE}let r=t.rules;if(r)for(let t,n=0,i=r.length;n<i&&(t=r[n]);n++)e(t,s);return t}(// super simple {...} lexer that returns a node tree
/**
 * @param {string} text
 * @return {!StyleNode}
 */
function(e){let t=new r;t.start=0,t.end=e.length;let s=t;for(let n=0,i=e.length;n<i;n++)if(e[n]===a){s.rules||(s.rules=[]);let e=s,t=e.rules[e.rules.length-1]||null;s=new r,s.start=n+1,s.parent=e,s.previous=t,e.rules.push(s)}else e[n]===u&&(s.end=n+1,s=s.parent||t);return t}(e=e.replace(c.comments,"").replace(c.port,"")),e)}// remove stuff we don't care about that may hinder parsing
/**
 * @param {string} cssText
 * @return {string}
 */function o(e,t,s=""){
// calc rule cssText
let n="";if(e.cssText||e.rules){let s=e.rules;if(s&&!
/**
 * @param {Array<StyleNode>} rules
 * @return {boolean}
 */
function(e){let t=e[0];return Boolean(t)&&Boolean(t.selector)&&0===t.selector.indexOf(p)}
/**
 * @param {string} cssText
 * @return {string}
 */(s))for(let e,r=0,i=s.length;r<i&&(e=s[r]);r++)n=o(e,t,n);else n=t?e.cssText:function(e){
/**
 * @param {string} cssText
 * @return {string}
 */
return function(e){return e.replace(c.mixinApply,"").replace(c.varApply,"")}
/** @enum {number} */(e=
/**
 * @param {string} cssText
 * @return {string}
 */
function(e){return e.replace(c.customProp,"").replace(c.mixinProp,"")}(e))}(e.cssText),n=n.trim(),n&&(n="  "+n+"\n")}// emit rule if there is cssText
return n&&(e.selector&&(s+=e.selector+" "+a+"\n"),s+=n,e.selector&&(s+=u+"\n\n")),s}const l={STYLE_RULE:1,KEYFRAMES_RULE:7,MEDIA_RULE:4,MIXIN_RULE:1e3},a="{",u="}",c={comments:/\/\*[^*]*\*+([^/*][^*]*\*+)*\//gim,port:/@import[^;]*;/gim,customProp:/(?:^[^;\-\s}]+)?--[^;{}]*?:[^{};]*?(?:[;\n]|$)/gim,mixinProp:/(?:^[^;\-\s}]+)?--[^;{}]*?:[^{};]*?{[^}]*?}(?:[;\n]|$)?/gim,mixinApply:/@apply\s*\(?[^);]*\)?\s*(?:[;\n]|$)?/gim,varApply:/[^;:]*?:[^;]*?var\([^;]*\)(?:[;\n]|$)?/gim,keyframesRule:/^@[^\s]*keyframes/,multipleSpaces:/\s+/g},p="--",d="@media",m="@";
// EXTERNAL MODULE: ./node_modules/@webcomponents/shadycss/src/common-regex.js?babel-target=es6
var h=s("O2xI");
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/unscoped-style-handler.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/** @type {!Set<string>} */const y=new Set;
/**
 * Add a specifically-marked style to the document directly, and only one copy of that style.
 *
 * @param {!HTMLStyleElement} style
 * @return {undefined}
 */
function S(e){const t=e.textContent;if(!y.has(t)){y.add(t);const e=document.createElement("style");e.setAttribute("shady-unscoped",""),e.textContent=t,document.head.appendChild(e)}}
/**
 * Check if a style is supposed to be unscoped
 * @param {!HTMLStyleElement} style
 * @return {boolean} true if the style has the unscoping attribute
 */function f(e){return e.hasAttribute("shady-unscoped")}
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/style-util.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// eslint-disable-line @typescript-eslint/no-unused-vars
// prettier-ignore
/**
 * @param {string|StyleNode} rules
 * @param {function(StyleNode)=} callback
 * @return {string}
 */function C(e,t){return e?("string"==typeof e&&(e=i(e)),t&&_(e,t),o(e,n.c)):""}
/**
 * @param {HTMLStyleElement} style
 * @return {StyleNode}
 */function w(e){return!e.__cssRules&&e.textContent&&(e.__cssRules=i(e.textContent)),e.__cssRules||null}// Tests if a rule is a keyframes selector, which looks almost exactly
// like a normal selector but is not (it has nothing to do with scoping
// for example).
/**
 * @param {StyleNode} rule
 * @return {boolean}
 */
/**
 * @param {StyleNode} node
 * @param {Function=} styleRuleCallback
 * @param {Function=} keyframesRuleCallback
 * @param {boolean=} onlyActiveRules
 */
function _(e,t,s,n){if(!e)return;let r=!1,i=e.type;if(n&&i===l.MEDIA_RULE){let t=e.selector.match(h.a);t&&(
// if rule is a non matching @media rule, skip subrules
window.matchMedia(t[1]).matches||(r=!0))}i===l.STYLE_RULE?t(e):s&&i===l.KEYFRAMES_RULE?s(e):i===l.MIXIN_RULE&&(r=!0);let o=e.rules;if(o&&!r)for(let e,r=0,i=o.length;r<i&&(e=o[r]);r++)_(e,t,s,n)}// add a string of cssText to the document.
/**
 * @param {string} cssText
 * @param {string} moniker
 * @param {Node} target
 * @param {Node} contextNode
 * @return {HTMLStyleElement}
 */
/**
 * Walk from text[start] matching parens and
 * returns position of the outer end paren
 * @param {string} text
 * @param {number} start
 * @return {number}
 */
function g(e,t){let s=0;for(let n=t,r=e.length;n<r;n++)if("("===e[n])s++;else if(")"===e[n]&&0==--s)return n;return-1}
/**
 * @param {string} str
 * @param {function(string, string, string, string)} callback
 */
/**
 * @type {function(*):*}
 */
window.ShadyDOM&&window.ShadyDOM.wrap;
/**
 * @param {Element | {is: string, extends: string}} element
 * @return {{is: string, typeExtension: string}}
 */
/**
 * Return the polymer-css-build "build type" applied to this element
 *
 * @param {!HTMLElement} element
 * @return {string} Can be "", "shady", or "shadow"
 */
function b(e){if(void 0!==n.a)
/** @type {string} */
return n.a;if(void 0===e.__cssBuild){
// try attribute first, as it is the common case
const t=e.getAttribute("css-build");if(t)e.__cssBuild=t;else{const t=
/**
 * For templates made with tagged template literals, polymer-css-build will
 * insert a comment of the form `<!--css-build:shadow-->`
 *
 * @param {!HTMLElement} element
 * @return {string}
 */
function(e){const t="template"===e.localName?
/** @type {!HTMLTemplateElement} */
e.content.firstChild:e.firstChild;if(t instanceof Comment){const e=t.textContent.trim().split(":");if("css-build"===e[0])return e[1]}return""}
/**
 * Check if the css build status is optimal, and do no unneeded work.
 *
 * @param {string=} cssBuild CSS build status
 * @return {boolean} css build is optimal or not
 */(e);""!==t&&
// remove build comment so it is not needlessly copied into every element instance
/**
 * @param {!HTMLElement} element
 */
function(e){const t="template"===e.localName?
/** @type {!HTMLTemplateElement} */
e.content.firstChild:e.firstChild;t.parentNode.removeChild(t)}
// EXTERNAL MODULE: ./node_modules/@webcomponents/shadycss/src/common-utils.js?babel-target=es6
(e),e.__cssBuild=t}}return e.__cssBuild||""}
/**
 * Check if the given element, either a <template> or <style>, has been processed
 * by polymer-css-build.
 *
 * If so, then we can make a number of optimizations:
 * - polymer-css-build will decompose mixins into individual CSS Custom Properties,
 * so the ApplyShim can be skipped entirely.
 * - Under native ShadowDOM, the style text can just be copied into each instance
 * without modification
 * - If the build is "shady" and ShadyDOM is in use, the styling does not need
 * scoping beyond the shimming of CSS Custom Properties
 *
 * @param {!HTMLElement} element
 * @return {boolean}
 */function x(e){return""!==b(e)}var E=s("i8Lh");
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/apply-shim.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/*
 * The apply shim simulates the behavior of `@apply` proposed at
 * https://tabatkins.github.io/specs/css-apply-rule/.
 * The approach is to convert a property like this:
 *
 *    --foo: {color: red; background: blue;}
 *
 * to this:
 *
 *    --foo_-_color: red;
 *    --foo_-_background: blue;
 *
 * Then where `@apply --foo` is used, that is converted to:
 *
 *    color: var(--foo_-_color);
 *    background: var(--foo_-_background);
 *
 * This approach generally works but there are some issues and limitations.
 * Consider, for example, that somewhere *between* where `--foo` is set and used,
 * another element sets it to:
 *
 *    --foo: { border: 2px solid red; }
 *
 * We must now ensure that the color and background from the previous setting
 * do not apply. This is accomplished by changing the property set to this:
 *
 *    --foo_-_border: 2px solid red;
 *    --foo_-_color: initial;
 *    --foo_-_background: initial;
 *
 * This works but introduces one new issue.
 * Consider this setup at the point where the `@apply` is used:
 *
 *    background: orange;
 *    `@apply` --foo;
 *
 * In this case the background will be unset (initial) rather than the desired
 * `orange`. We address this by altering the property set to use a fallback
 * value like this:
 *
 *    color: var(--foo_-_color);
 *    background: var(--foo_-_background, orange);
 *    border: var(--foo_-_border);
 *
 * Note that the default is retained in the property set and the `background` is
 * the desired `orange`. This leads us to a limitation.
 *
 * Limitation 1:

 * Only properties in the rule where the `@apply`
 * is used are considered as default values.
 * If another rule matches the element and sets `background` with
 * less specificity than the rule in which `@apply` appears,
 * the `background` will not be set.
 *
 * Limitation 2:
 *
 * When using Polymer's `updateStyles` api, new properties may not be set for
 * `@apply` properties.

*/
// prettier-ignore
// eslint-disable-line @typescript-eslint/no-unused-vars
const v=/;\s*/m,R=/^\s*(initial)|(inherit)\s*$/,T=/\s*!important/;// eslint-disable-line @typescript-eslint/no-unused-vars
// map of mixin to property names
// --foo: {border: 2px} -> {properties: {(--foo, ['border'])}, dependants: {'element-name': proto}}
class I{constructor(){
/** @type {!Object<string, !MixinMapEntry>} */
this._map={}}
/**
   * @param {string} name
   * @param {!PropertyEntry} props
   */set(e,t){e=e.trim(),this._map[e]={properties:t,dependants:{}}}
/**
   * @param {string} name
   * @return {MixinMapEntry}
   */get(e){return e=e.trim(),this._map[e]||null}}
/**
 * Callback for when an element is marked invalid
 * @type {?function(string)}
 */let O=null;
/** @unrestricted */class M{constructor(){
/** @type {?string} */
this._currentElement=null,
/** @type {HTMLMetaElement} */
this._measureElement=null,this._map=new I}
/**
   * return true if `cssText` contains a mixin definition or consumption
   * @param {string} cssText
   * @return {boolean}
   */detectMixin(e){return Object(E.a)(e)}
/**
   * Gather styles into one style for easier processing
   * @param {!HTMLTemplateElement} template
   * @return {HTMLStyleElement}
   */gatherStyles(e){const t=
/**
 * @param {Element|DocumentFragment} element
 * @return {string}
 */
function(e){
/** @type {!Array<string>} */
const t=[],s=
/** @type {!NodeList<!HTMLStyleElement>} */
e.querySelectorAll("style");for(let e=0;e<s.length;e++){const r=s[e];f(r)?n.d||(S(r),r.parentNode.removeChild(r)):(t.push(r.textContent),r.parentNode.removeChild(r))}return t.join("").trim()}
/**
 * Split a selector separated by commas into an array in a smart way
 * @param {string} selector
 * @return {!Array<string>}
 */(e.content);if(t){const s=
/** @type {!HTMLStyleElement} */
document.createElement("style");return s.textContent=t,e.content.insertBefore(s,e.content.firstChild),s}return null}
/**
   * @param {!HTMLTemplateElement} template
   * @param {string} elementName
   * @return {StyleNode}
   */transformTemplate(e,t){void 0===e._gatheredStyle&&(e._gatheredStyle=this.gatherStyles(e))
/** @type {HTMLStyleElement} */;const s=e._gatheredStyle;return s?this.transformStyle(s,t):null}
/**
   * @param {!HTMLStyleElement} style
   * @param {string} elementName
   * @return {StyleNode}
   */transformStyle(e,t=""){let s=w(e);return this.transformRules(s,t),e.textContent=C(s),s}
/**
   * @param {!HTMLStyleElement} style
   * @return {StyleNode}
   */transformCustomStyle(e){let t=w(e);return _(t,e=>{":root"===e.selector&&(e.selector="html"),this.transformRule(e)}),e.textContent=C(t),t}
/**
   * @param {StyleNode} rules
   * @param {string} elementName
   */transformRules(e,t){this._currentElement=t,_(e,e=>{this.transformRule(e)}),this._currentElement=null}
/**
   * @param {!StyleNode} rule
   */transformRule(e){e.cssText=this.transformCssText(e.parsedCssText,e),// :root was only used for variable assignment in property shim,
// but generates invalid selectors with real properties.
// replace with `:host > *`, which serves the same effect
":root"===e.selector&&(e.selector=":host > *")}
/**
   * @param {string} cssText
   * @param {!StyleNode} rule
   * @return {string}
   */transformCssText(e,t){// consume mixins
// produce variables
return e=e.replace(h.c,(e,s,n,r)=>this._produceCssProperties(e,s,n,r,t)),this._consumeCssProperties(e,t)}
/**
   * @param {string} property
   * @return {string}
   */_getInitialValueForProperty(e){return this._measureElement||(this._measureElement=
/** @type {HTMLMetaElement} */
document.createElement("meta"),this._measureElement.setAttribute("apply-shim-measure",""),this._measureElement.style.all="initial",document.head.appendChild(this._measureElement)),window.getComputedStyle(this._measureElement).getPropertyValue(e)}
/**
   * Walk over all rules before this rule to find fallbacks for mixins
   *
   * @param {!StyleNode} startRule
   * @return {!Object}
   */_fallbacksFromPreviousRules(e){
// find the "top" rule
let t=e;for(;t.parent;)t=t.parent;const s={};let n=!1;return _(t,t=>{
// stop when we hit the input rule
n=n||t===e,n||// NOTE: Only matching selectors are "safe" for this fallback processing
// It would be prohibitive to run `matchesSelector()` on each selector,
// so we cheat and only check if the same selector string is used, which
// guarantees things like specificity matching
t.selector===e.selector&&Object.assign(s,this._cssTextToMap(t.parsedCssText))}),s}
/**
   * replace mixin consumption with variable consumption
   * @param {string} text
   * @param {!StyleNode=} rule
   * @return {string}
   */_consumeCssProperties(e,t){
/** @type {Array} */
let s=null;// loop over text until all mixins with defintions have been applied
for(;s=h.b.exec(e);){let n=s[0],r=s[1],i=s.index,o=i+n.indexOf("@apply"),l=i+n.length,a=e.slice(0,o),u=e.slice(l),c=t?this._fallbacksFromPreviousRules(t):{};Object.assign(c,this._cssTextToMap(a));let p=this._atApplyToCssProperties(r,c);// use regex match position to replace mixin, keep linear processing time
e=`${a}${p}${u}`,// move regex search to _after_ replacement
h.b.lastIndex=i+p.length}return e}
/**
   * produce variable consumption at the site of mixin consumption
   * `@apply` --foo; -> for all props (${propname}: var(--foo_-_${propname}, ${fallback[propname]}}))
   * Example:
   *  border: var(--foo_-_border); padding: var(--foo_-_padding, 2px)
   *
   * @param {string} mixinName
   * @param {Object} fallbacks
   * @return {string}
   */_atApplyToCssProperties(e,t){e=e.replace(v,"");let s=[],n=this._map.get(e);if(// if we depend on a mixin before it is created
// make a sentinel entry in the map to add this element as a dependency for when it is defined.
n||(this._map.set(e,{}),n=this._map.get(e)),n){let r,i,o;this._currentElement&&(n.dependants[this._currentElement]=!0);const l=n.properties;for(r in l)o=t&&t[r],i=[r,": var(",e,"_-_",r],o&&i.push(",",o.replace(T,"")),i.push(")"),T.test(l[r])&&i.push(" !important"),s.push(i.join(""))}return s.join("; ")}
/**
   * @param {string} property
   * @param {string} value
   * @return {string}
   */_replaceInitialOrInherit(e,t){let s=R.exec(t);return s&&(
// initial
// replace `initial` with the concrete initial value for this property
t=s[1]?this._getInitialValueForProperty(e):"apply-shim-inherit"),t}
/**
   * "parse" a mixin definition into a map of properties and values
   * cssTextToMap('border: 2px solid black') -> ('border', '2px solid black')
   * @param {string} text
   * @param {boolean=} replaceInitialOrInherit
   * @return {!Object<string, string>}
   */_cssTextToMap(e,t=!1){let s,n,r=e.split(";"),i={};for(let e,o,l=0;l<r.length;l++)e=r[l],e&&(o=e.split(":"),// ignore lines that aren't definitions like @media
o.length>1&&(s=o[0].trim(),// some properties may have ':' in the value, like data urls
n=o.slice(1).join(":"),t&&(n=this._replaceInitialOrInherit(s,n)),i[s]=n));return i}
/**
   * @param {MixinMapEntry} mixinEntry
   */_invalidateMixinEntry(e){if(O)for(let t in e.dependants)t!==this._currentElement&&O(t)}
/**
   * @param {string} matchText
   * @param {string} propertyName
   * @param {?string} valueProperty
   * @param {?string} valueMixin
   * @param {!StyleNode} rule
   * @return {string}
   */_produceCssProperties(e,t,s,n,r){if(
// handle case where property value is a mixin
s&&
// form: --mixin2: var(--mixin1), where --mixin1 is in the map
function e(t,s){
// find 'var('
let n=t.indexOf("var(");if(-1===n)
// no var?, everything is prefix
return s(t,"","","");//${prefix}var(${inner})${suffix}
let r=g(t,n+3),i=t.substring(n+4,r),o=t.substring(0,n),l=e(t.substring(r+1),s),a=i.indexOf(",");// value and fallback args should be trimmed to match in property lookup
return-1===a?s(o,i.trim(),"",l):s(o,i.substring(0,a).trim(),i.substring(a+1).trim(),l);// var(${value},${fallback})
}
/**
 * @param {Element} element
 * @param {string} value
 */(s,(e,t)=>{t&&this._map.get(t)&&(n=`@apply ${t};`)}),!n)return e;let i=this._consumeCssProperties(""+n,r),o=e.slice(0,e.indexOf("--")),l=this._cssTextToMap(i,!0),a=l,u=this._map.get(t),c=u&&u.properties;c?
// NOTE: since we use mixin, the map of properties is updated here
// and this is what we want.
a=Object.assign(Object.create(c),l):this._map.set(t,a);let p,d,m=[],h=!1;for(p in a)d=l[p],// if property not defined by current mixin, set initial
void 0===d&&(d="initial"),c&&!(p in c)&&(h=!0),m.push(`${t}_-_${p}: ${d}`);return h&&this._invalidateMixinEntry(u),u&&(u.properties=a),// because the mixinMap is global, the mixin might conflict with
// a different scope's simple variable definition:
// Example:
// some style somewhere:
// --mixin1:{ ... }
// --mixin2: var(--mixin1);
// some other element:
// --mixin1: 10px solid red;
// --foo: var(--mixin1);
// In this case, we leave the original variable definition in place.
s&&(o=`${e};${o}`),`${o}${m.join("; ")};`}}
/* exports */
/* eslint-disable no-self-assign */M.prototype.detectMixin=M.prototype.detectMixin,M.prototype.transformStyle=M.prototype.transformStyle,M.prototype.transformCustomStyle=M.prototype.transformCustomStyle,M.prototype.transformRules=M.prototype.transformRules,M.prototype.transformRule=M.prototype.transformRule,M.prototype.transformTemplate=M.prototype.transformTemplate,M.prototype._separator="_-_",
/* eslint-enable no-self-assign */
Object.defineProperty(M.prototype,"invalidCallback",{
/** @return {?function(string)} */
get:()=>O,
/** @param {?function(string)} cb */
set(e){O=e}});
/* harmony default export */var A=M;
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/template-map.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @const {!Object<string, !HTMLTemplateElement>}
 */
/* harmony default export */var L={};
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/src/apply-shim-utils.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// eslint-disable-line @typescript-eslint/no-unused-vars
/*
 * Utilities for handling invalidating apply-shim mixins for a given template.
 *
 * The invalidation strategy involves keeping track of the "current" version of a template's mixins, and updating that count when a mixin is invalidated.
 * The template
 */
/** @const {string} */const P="_applyShimCurrentVersion",j="_applyShimNextVersion",V=Promise.resolve();
/** @const {string} */
/**
 * @param {string} elementName
 */
function B(e){let t=L[e];t&&
/**
 * This function can be called multiple times to mark a template invalid
 * and signal that the style inside must be regenerated.
 *
 * Use `startValidatingTemplate` to begin an asynchronous validation cycle.
 * During that cycle, call `templateIsValidating` to see if the template must
 * be revalidated
 * @param {HTMLTemplateElement} template
 */
function(e){
// default the current version to 0
e[P]=e[P]||0,// ensure the "validating for" flag exists
e._applyShimValidatingVersion=e._applyShimValidatingVersion||0,// increment the next version
e[j]=(e[j]||0)+1}
/**
 * @param {string} elementName
 * @return {boolean}
 */(t)}
/**
 * @param {HTMLTemplateElement} template
 * @return {boolean}
 */
function N(e){return e[P]===e[j]}
/**
 * @param {string} elementName
 * @return {boolean}
 */
/**
 * Returns true if the template is currently invalid and `startValidating` has been called since the last invalidation.
 * If false, the template must be validated.
 * @param {HTMLTemplateElement} template
 * @return {boolean}
 */
function $(e){return!N(e)&&e._applyShimValidatingVersion===e[j]}
/**
 * the template is marked as `validating` for one microtask so that all instances
 * found in the tree crawl of `applyStyle` will update themselves,
 * but the template will only be updated once.
 * @param {string} elementName
 */
/**
 * Begin an asynchronous invalidation cycle.
 * This should be called after every validation of a template
 *
 * After one microtask, the template will be marked as valid until the next call to `invalidateTemplate`
 * @param {HTMLTemplateElement} template
 */
function k(e){
// remember that the current "next version" is the reason for this validation cycle
e._applyShimValidatingVersion=e[j],// however, there only needs to be one async task to clear the counters
e._validating||(e._validating=!0,V.then((function(){
// sync the current version to let future invalidations cause a refresh cycle
e[P]=e[j],e._validating=!1})))}
/**
 * @return {boolean}
 */
// EXTERNAL MODULE: ./node_modules/@webcomponents/shadycss/src/custom-style-interface.js?babel-target=es6 + 1 modules
s("gXhW");
// CONCATENATED MODULE: ./node_modules/@webcomponents/shadycss/entrypoints/apply-shim.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// prettier-ignore
// prettier-ignore
// eslint-disable-line @typescript-eslint/no-unused-vars
// prettier-ignore
/** @const {ApplyShim} */const D=new A;class F{constructor(){
/** @type {?CustomStyleInterfaceInterface} */
this.customStyleInterface=null,D.invalidCallback=B}ensure(){this.customStyleInterface||window.ShadyCSS.CustomStyleInterface&&(this.customStyleInterface=
/** @type {!CustomStyleInterfaceInterface} */
window.ShadyCSS.CustomStyleInterface,this.customStyleInterface.transformCallback=e=>{D.transformCustomStyle(e)},this.customStyleInterface.validateCallback=()=>{requestAnimationFrame(()=>{this.customStyleInterface.enqueued&&this.flushCustomStyles()})})}
/**
   * @param {!HTMLTemplateElement} template
   * @param {string} elementName
   */prepareTemplate(e,t){if(this.ensure(),x(e))return;L[t]=e;let s=D.transformTemplate(e,t);// save original style ast to use for revalidating instances
e._styleAst=s}flushCustomStyles(){if(this.ensure(),!this.customStyleInterface)return;let e=this.customStyleInterface.processStyles();if(this.customStyleInterface.enqueued){for(let t=0;t<e.length;t++){let s=e[t],n=this.customStyleInterface.getStyleForCustomStyle(s);n&&D.transformCustomStyle(n)}this.customStyleInterface.enqueued=!1}}
/**
   * @param {HTMLElement} element
   * @param {Object=} properties
   */styleSubtree(e,t){if(this.ensure(),t&&Object(E.c)(e,t),e.shadowRoot){this.styleElement(e);let t=
/** @type {!ParentNode} */
e.shadowRoot.children||e.shadowRoot.childNodes;for(let e=0;e<t.length;e++)this.styleSubtree(
/** @type {HTMLElement} */
t[e])}else{let t=e.children||e.childNodes;for(let e=0;e<t.length;e++)this.styleSubtree(
/** @type {HTMLElement} */
t[e])}}
/**
   * @param {HTMLElement} element
   */styleElement(e){this.ensure();let{is:t}=function(e){let t=e.localName,s="",n="";
/*
  NOTE: technically, this can be wrong for certain svg elements
  with `-` in the name like `<font-face>`
  */
return t?t.indexOf("-")>-1?s=t:(n=t,s=e.getAttribute&&e.getAttribute("is")||""):(s=
/** @type {?} */
e.is,n=
/** @type {?} */
e.extends),{is:s,typeExtension:n}}(e),s=L[t];if((!s||!x(s))&&s&&!N(s)){
// only revalidate template once
$(s)||(this.prepareTemplate(s,t),k(s));// update this element instance
let n=e.shadowRoot;if(n){let e=
/** @type {HTMLStyleElement} */
n.querySelector("style");e&&(
// reuse the template's style ast, it has all the original css text
e.__cssRules=s._styleAst,e.textContent=C(s._styleAst))}}}
/**
   * @param {Object=} properties
   */styleDocument(e){this.ensure(),this.styleSubtree(document.body,e)}}if(!window.ShadyCSS||!window.ShadyCSS.ScopingShim){const e=new F;let t=window.ShadyCSS&&window.ShadyCSS.CustomStyleInterface;
/** @suppress {duplicate} */window.ShadyCSS={
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     * @param {string=} elementExtends
     */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
prepareTemplate(t,s,n){e.flushCustomStyles(),e.prepareTemplate(t,s)},
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     * @param {string=} elementExtends
     */
prepareTemplateStyles(e,t,s){window.ShadyCSS.prepareTemplate(e,t,s)},
/**
     * @param {!HTMLTemplateElement} template
     * @param {string} elementName
     */
prepareTemplateDom(e,t){},
// eslint-disable-line @typescript-eslint/no-unused-vars
/**
     * @param {!HTMLElement} element
     * @param {Object=} properties
     */
styleSubtree(t,s){e.flushCustomStyles(),e.styleSubtree(t,s)},
/**
     * @param {!HTMLElement} element
     */
styleElement(t){e.flushCustomStyles(),e.styleElement(t)},
/**
     * @param {Object=} properties
     */
styleDocument(t){e.flushCustomStyles(),e.styleDocument(t)},
/**
     * @param {Element} element
     * @param {string} property
     * @return {string}
     */
getComputedStyleValue:(e,t)=>Object(E.b)(e,t),flushCustomStyles(){e.flushCustomStyles()},nativeCss:n.c,nativeShadow:n.d,cssBuild:n.a,disableRuntime:n.b},t&&(window.ShadyCSS.CustomStyleInterface=t)}window.ShadyCSS.ApplyShim=D},
/***/i8Lh:
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"c",(function(){return r})),
/* harmony export (binding) */s.d(t,"b",(function(){return i})),
/* harmony export (binding) */s.d(t,"a",(function(){return o}));
/* harmony import */var n=s("O2xI");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @param {Element} element
 * @param {Object=} properties
 */function r(e,t){
// remove previous properties
for(let s in t)
// NOTE: for bc with shim, don't apply null values.
null===s?e.style.removeProperty(s):e.style.setProperty(s,t[s])}
/**
 * @param {Element} element
 * @param {string} property
 * @return {string}
 */function i(e,t){
/**
   * @const {string}
   */
const s=window.getComputedStyle(e).getPropertyValue(t);return s?s.trim():""}
/**
 * return true if `cssText` contains a mixin definition or consumption
 * @param {string} cssText
 * @return {boolean}
 */function o(e){const t=n.b.test(e)||n.c.test(e);// reset state of the regexes
return n.b.lastIndex=0,n.c.lastIndex=0,t}
/***/}}]);